import BaseAttribute from './baseAttribute';

export default abstract class ValueAttribute extends BaseAttribute {
  public value: number = 0;
  public max?: number;
}
